import { render, staticRenderFns } from "./bon-medical.html?vue&type=template&id=7fe9611d&scoped=true&external"
import script from "./bon-medical.js?vue&type=script&lang=js&external"
export * from "./bon-medical.js?vue&type=script&lang=js&external"
import style0 from "./bon-medical.scss?vue&type=style&index=0&id=7fe9611d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9611d",
  null
  
)

export default component.exports